import React from 'react';
import PropTypes from 'prop-types';
import { fetchAccessPointAccessMethods } from 'store/actions/accessPoints/access-methods/fetch/fetchAccessPointAccessMethods';
import { Section } from 'components/ui/table/elements';
import AccessMethodsListContainer from '../access-methods/list/AccessMethodsListContainer';
import Actions from 'components/ui/general/Actions';
import AddButton from 'components/button/AddButton';
import Breadcrumbs, { generateBreadcrumbsFromPath } from 'components/layout/Layout/Breadcrumbs';
import Column from 'components/ui/show/Column';
import EditButton from 'components/button/EditButton';
import Header from 'components/ui/general/Header';
import InnerColumn from 'components/ui/show/InnerColumn';
import ProductTextField from 'components/field/ProductTextField';
import TextField from 'components/show/TextField';
import Title from 'components/ui/general/Title';
import translate from 'components/hoc/translate';
import utils from 'helpers/utils';

const AccessPointShow = (props) => {
    const {
        id,
        product,
        record,
        resource,
        translate,
    } = props;

    const breadcrumbs = [];
    const editUrl = window.location.pathname.split('/');

    editUrl.shift();
    editUrl.pop(); // Removes show.

    if (utils.isEmpty(product)) {
        breadcrumbs.push(
            {
                label: translate('resources.access_points.title'),
                link: '/access-points',
            },
            {
                label: record.title,
            }
        );
    } else {
        breadcrumbs.push(
            ...generateBreadcrumbsFromPath({
                products: translate('resources.products.title'),
                [product.id]: product,
                'access-point': translate('resources.access_points.title'),
                [id]: record,
            }, props)
        );
    }

    return (
        <div>
            <Breadcrumbs breadcrumbs={ breadcrumbs } />

            <Header>
                <Title title={ record.title } />

                <Actions>
                    <EditButton url={ window.location.pathname.replace('show', '') } />
                </Actions>
            </Header>

            <Section>
                <Column>
                    <InnerColumn>
                        <TextField
                            label='resources.products.fields.title'
                            value={ record.title }
                        />

                        <ProductTextField
                            label='resources.bookings.fields.product'
                            record={ record }
                            source='product_id'
                        />
                    </InnerColumn>
                </Column>
            </Section>

            <Section>
                <Column
                    actions={
                        <AddButton basePath={ `${ editUrl.join('/') }/access-method` } />
                    }
                    title={ translate('resources.products.forms.access_methods') }
                >
                    <InnerColumn>
                        <AccessMethodsListContainer
                            action={ fetchAccessPointAccessMethods }
                            id={ id }
                            resource={ resource }
                            source='access-points-access-methods'
                        />
                    </InnerColumn>
                </Column>
            </Section>
        </div>
    );
};

AccessPointShow.propTypes = {
    id: PropTypes.number.isRequired,
    product: PropTypes.shape({
        id: PropTypes.string,
    }),
    record: PropTypes.shape({
        product_id: PropTypes.string.isRequired,
        title: PropTypes.string.isRequired,
    }).isRequired,
    resource: PropTypes.string.isRequired,
    translate: PropTypes.func,
};

export default translate(AccessPointShow);


// WEBPACK FOOTER //
// ./src/pages/accessPoints/show/AccessPointShow.js